export default {
  openButton: 'Generate with AI',
  title: 'Generate {entity} with AI',
  subtitleSetup: 'Step 1 of 2 · Build the plan of what will be written',
  subtitleReview: 'Step 2 of 2 · Review before adding them',
  close: 'Close',
  back: 'Back to the plan',
  questionsEntity: 'Questions',

  // Step 1
  fromDesign: 'From the Instructional Design: "{piece}"',
  testScore: '{score} pts',
  themeLabel: 'Topic or focus (optional)',
  themePlaceholder: 'E.g. frame the questions around the cold chain case',
  themeHint: 'Guides what the questions are framed around',
  themeInfo:
    'Narrows the context the questions are set in, without changing what they measure: a case, a scenario or an emphasis. E.g. "based on a temperature log", "in the context of a small business". It is not a place to give instructions.',
  existingTitle: 'This Instrument already has {count} questions ({score} pts). The plan starts with what is missing:',
  coverageCount: '{count} already',
  coverageNone: 'no questions',
  planTitle: '{entity} plan',
  planHint:
    'One row per question: which {entity} it asks about, what type it is and how much it is worth. This is exactly what will be written — the AI decides neither the count nor the score.',
  colType: 'Type',
  colCorrect: 'Correct',
  colOptions: 'Alternatives',
  colScore: 'Score',
  addRow: 'Add a question to the plan',
  removeRow: 'Remove from the plan',
  planEmpty:
    'The plan is empty. Add at least one question and choose which {entity} it asks about.',
  planTotal: 'Plan total: {total} pts',
  planTotalOf: 'Plan total: {total} of {score} pts',
  typesDisabled:
    '{types} are not offered: the Evaluative Situation "{situation}" does not enable them.',
  typeRedaction: 'Open-ended',
  typeSimpleSelection: 'Single Choice',
  typeMultipleSelection: 'Multiple Choice',

  // Step 2
  streaming: 'Writing... {done} of {total} done',
  reviewHint:
    '{count} proposed questions. None have been saved yet: discard the ones that do not work and add the rest.',
  reviewEmpty: 'No questions left to review.',
  points: '{score} pts',
  missingRows:
    'The AI did not return {count} of the questions in the plan. Go back and generate them again if you need them.',
  maxWords: 'Suggested maximum length: {words} words',
  discard: 'Discard',
  redo: 'Regenerate this question only',
  restore: 'Restore',

  // Actions
  generate: 'Generate {count}',
  save: 'Add {count}',
  saved: '{count} questions were added.',
  savingProgress: 'Saving... {done} of {total}',

  // Errors
  generateError:
    'An error occurred while generating the questions with AI. Please try again.',
  generateEmpty:
    'The AI did not propose any question that can be scored. Try again, or adjust the plan.',
  noTypesAvailable:
    'The Evaluative Situation "{situation}" does not enable questions in this Instrument.',
  noDimensions:
    'This instrument’s rubric has no {entity} to attach questions to yet. Create the rubric first.',
  noCriterias:
    'This evaluation does not declare any {entity}, which is what the questions are meant to measure. Declare them in the Instructional Design and try again.',
}
